<style src="./BoardTaskCommands.scss" lang="scss"></style>
<template>
  <aside class="board-taskcommands">
    <button
      type-="button"
      v-if="canShowOpenTask"
      class="cp1-small-button cp1-button__warning"
      @click="openTask">
      Abrir Tarefa
    </button>

    <button
      type="button"
      v-if="canShowFinishTask"
      class="cp1-small-button cp1-button__danger"
      @click="finishTask">
      Concluir Tarefa
    </button>
  </aside>
</template>

<script>
export default {
  name: 'BoardTaskCommands',
  props: {
    canShowOpenTask: {
      default: false
    },
    canShowFinishTask: {
      default: false
    }
  },
  methods: {
    openTask () { this.$emit('open-task') },
    finishTask () { this.$emit('finish-task') }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/board/components/board-details/components/board-task-commands/BoardTaskCommands.vue